import {Dispatch} from "redux";
import {AppActions} from "../../index";
import {
    RequestExecption,
    RESET_REQUEST_ERROR,
    SET_IS_LOADING_STATUS,
    SET_REQUEST_ERROR,
    SET_STATUS,
    Status
} from "../../types/general";
import {GeneralService} from "../../../services/GeneralService";

const setRequestError = (error: RequestExecption): AppActions => ({
    type: SET_REQUEST_ERROR,
    error
});

export const resetRequestError = (): AppActions => ({
    type: RESET_REQUEST_ERROR
});

const setIsLoadingStatus = (isLoadingStatus: boolean): AppActions => ({
    type: SET_IS_LOADING_STATUS,
    isLoadingStatus
});

export const setStatus = (status: Status | null): AppActions => ({
    type: SET_STATUS,
    status
});

export const getStatus = (key: string) => {
    return (dispatch: Dispatch<AppActions>) => {
        dispatch(setIsLoadingStatus(true))
        return GeneralService.getStatus(key)
            .then(status => dispatch(setStatus(status)))
            .then(_ => dispatch(resetRequestError()))
            .catch(err => dispatch(setRequestError(err)))
            .finally(() => dispatch(setIsLoadingStatus(false)))
    }
}
